import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { calculator } from '../../../base/utils';
import { Note } from '../../../helbest';
import { API } from '../../../request/api';
import { _Cart_Add } from '../../../store/actions/cart_actions';

const useProductItem = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const [shareModal, setShareModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(props?.productDetailId || false);

  const HideModal = () => {
    setIsModalVisible(false);
  };
  const showModal_visible = () => {
    setIsModalVisible(true);
  };

  const getQuantity = (product_id) => {
    if (!Array.isArray(store.Cart)) {
      return 0;
    }
    const fp = store.Cart.find((product) => product.id === product_id);
    if (fp) {
      return fp.quantity;
    }
    return 0;
  };

  const add_to_cart = (product) => {
    const quantity = getQuantity(product.id);
    const cart = Array.isArray(store.Cart) ? store.Cart : [];
    API.post
      .card(product.id, store.Login.city_id, quantity + product.count_step, cart)
      .then((response) => {
        if (response.success) {
          dispatch(_Cart_Add(product));
          calculator();
          Note.info(
            <>
              <span style={{ display: 'block' }}>کالا به سبد خرید اضافه شد.</span>
              <span>
                تعداد کالا در سبد خرید: <b>{quantity + product.count_step}</b> {product.unit}
              </span>
            </>
          );
          // history.push("/cart/");
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  return [
    shareModal,
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    store,
    history
  ];
};

export default useProductItem;
